// View where two users chat with each other
import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash";
import moment from "moment";
import AjaxButton from "../../../form/ajax_button";
import classNames from "classnames";
import ChatMessage from "./chat_message";
import {setDirectMessageError} from "virtual_congress/exhibition_actions";
import {filterMessagesForChat, useUnreadMessages} from "./utils";
import {directMessageMarkMessagesRead, directMessageSetReceiverTagOwner} from "../../exhibition_actions";
import ChatMessageTagOwnerImage from "./chat_message_tag_owner_image";
import axios from "axios";

export default function DirectMessageView({setSearchResults, translations, disableBackButton}) {
  const dispatch = useDispatch()
  const receiverTagOwner = useSelector((state) => state.directMessaging.receiverTagOwner)
  const [message, setMessage] = useState("");
  const [keepScrolledBottom, setKeepScrolledBottom] = useState(true);
  const sendButton = useRef(null);
  const inputFieldRef = useRef(null);
  const messageEndRef = useRef(null);
  const chatContainerRef = useRef(null);
  const directMessageUrl = useSelector((state) => state.directMessaging.directMessageUrl)
  const messages = useSelector((state) => state.directMessaging.messages)
  const chatError = useSelector((state) => state.directMessaging.chatError)
  const tagOwner = useSelector((state) => state.tagOwner)
  const unreadMessages = useUnreadMessages(receiverTagOwner.id)
  const isDirectMessagingEnabled = useSelector((state) => state.directMessaging.isDirectMessagingEnabled)
  const directMessagingTranslationsJson = useSelector(state => state.htmlContents.find(hc => hc.identifier == "direct_messaging.translations"))
  let directMessagingTranslations = null
  const directMessageCompleteParticipantListUrl = useSelector((state) => state.directMessaging.directMessageCompleteParticipantListUrl)
  const useOnlineStatus = useSelector((state) => state.directMessaging?.useOnlineStatus)
  const [isLoadingParticipantList, setIsLoadingParticipantList] = useState(useOnlineStatus)
  const [participantList, setParticipantList] = useState([])

  try {
    directMessagingTranslations = JSON.parse(directMessagingTranslationsJson.html)
  } catch (e) {
    if (directMessagingTranslationsJson?.json?.default) {
      directMessagingTranslations = directMessagingTranslationsJson?.json?.default;
    } else {
      directMessagingTranslations = {}
      console.error("Error parsing direct messaging translations.", e)
      console.error(directMessagingTranslationsJson)
    }
  }


  useEffect(() => {
    if (useOnlineStatus) {
      setIsLoadingParticipantList(true)

      axios.post(directMessageCompleteParticipantListUrl, {tag_owner_ids: [receiverTagOwner.id]}).then(data => {
          if (data.data.status === "OK") {
            setParticipantList(data.data.tagOwnerResults)
          } else {
            alert(data.data.message || "A error occurred while loading.")
          }
          setIsLoadingParticipantList(false)
        },
        error => {
          alert(error)
          console.error(error)
          setParticipantList([])
        }).then(function () {
        setIsLoadingParticipantList(false)
      })
    }
  }, [])

  const groupMessages = (messages) => {
    let groupedMessages = []
    messages.forEach((message) => {
      let lastMessage = groupedMessages[groupedMessages.length - 1]
      if (groupedMessages.length > 0 && lastMessage && lastMessage.tagOwnerId === message.sender_tag_owner_id) {
        // if a message was deleted the id should change so react knows about it
        lastMessage.id += message.id
        lastMessage.body += "\n" + message.body
        lastMessage.read_at = message.read_at
      } else {
        groupedMessages.push({
          id: message.id,
          name: message.sender_tag_owner.name,
          tagOwnerId: message.sender_tag_owner.id,
          tagOwner: message.sender_tag_owner,
          body: message.body,
          read_at: message.read_at
        })
      }
    })
    return groupedMessages
  }

  const filteredMessages = _.orderBy(filterMessagesForChat(messages, receiverTagOwner.id), message => moment(message.created_at))
  const groupedMessages = groupMessages(filteredMessages)

  const scrollToBottom = () => {
    if (keepScrolledBottom && chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight
      // messageEndRef.current.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    }
  }

  const dismissError = () => {
    dispatch(setDirectMessageError(null))
  }

  scrollToBottom()

  useEffect(() => {
    // Without timeout it does not scroll down initially - maybe because the dom is not rendered fully event tough useEffect is executed after the render cycle?
    setTimeout(() => {
      scrollToBottom()
    }, 800)
  }, [receiverTagOwner])

  useEffect(() => {
    scrollToBottom()
  }, [messages, chatContainerRef])

  useEffect(() => {
    if (inputFieldRef.current) {
      inputFieldRef.current.focus()
    }
  }, [])

  useEffect(() => {
    if (unreadMessages.length > 0) {
      dispatch(directMessageMarkMessagesRead(unreadMessages.map((unreadMessage) => unreadMessage.id)));
    }
  }, [unreadMessages])


  const handleChatInput = (event) => {
    if (event.key === 'Enter' && !event.shiftKey && sendButton.current && event.target.value) {
      event.preventDefault()
      event.stopPropagation()
      sendButton.current.click()
    }
  }

  const onMessagesScrolled = (event) => {
    setKeepScrolledBottom(event.target.scrollTop + event.target.offsetHeight >= event.target.scrollHeight -1)
  }

  console.log({isDirectMessagingEnabled,  "receiverTagOwner": receiverTagOwner})

  const receiverTagOwnerDirectMessagingEnabled = receiverTagOwner.direct_messages_enabled || receiverTagOwner.isDirectMessagingEnabled

  let onlineState = null
  if (useOnlineStatus) {
    if (isLoadingParticipantList) {
      onlineState = "loading"
    } else if (participantList.some(tagOwner => tagOwner.id === receiverTagOwner.id && tagOwner.is_online)) {
      onlineState = "online"
    } else {
      onlineState = "offline"
    }
  }

  return <>
    {!disableBackButton && <div className="row">
      <div className="col-12">
        <div className="back-button d-flex justify-content-between align-items-center" onClick={() => {
          dispatch(directMessageSetReceiverTagOwner(null))
          setSearchResults(null)
        }}>
          <div>{translations.backText || "Back"}</div>
          <div className={receiverTagOwner.moderator ? "moderator text-right" : "text-right"}>
            <ChatMessageTagOwnerImage onlineState={onlineState} tagOwner={receiverTagOwner} />
            {" " + receiverTagOwner.name}
          </div>
        </div>
      </div>
    </div>}
    <div className="row no-gutters">
      <div className="col-12">
        {chatError &&
        <div className="alert alert-danger alert-dismissible fade show" role="alert">
          {chatError}
          <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={dismissError}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        }
      </div>
      <div className="col-12 chat-container" ref={chatContainerRef} onScroll={onMessagesScrolled}>
        {groupedMessages.map((message, index) => {
          return <ChatMessage
            key={message.id}
            tagOwner={tagOwner}
            message={message}
          />
        })}
        <div className={"messageEndRef"} ref={messageEndRef}/>
      </div>
      {isDirectMessagingEnabled && receiverTagOwnerDirectMessagingEnabled && <div className="col-12">
        <div className="input-group chat-window-input-form-group">
          <input
            ref={inputFieldRef}
            className="form-control"
            type="text"
            onKeyDown={handleChatInput}
            placeholder={translations.sendMessagePlaceholder || directMessagingTranslations?.sendMessagePlaceholder || "Write your message"}
            value={message}
            onChange={(event) => {
              setMessage(event.target.value)
            }}
          />
          {message ? <div className="input-group-append">
            <AjaxButton
              buttonRef={sendButton}
              method="post"
              labelSending={translations.sendMessageButtonSending || directMessagingTranslations?.sendMessageButtonSending || "Sending ..."}
              className={classNames("btn btn-outline-success btn-ueg btn-ueg-styled")}
              icon="fa-angle-double-right"
              url={directMessageUrl}
              data={() => {
                return {
                  receiver_tag_owner_id: receiverTagOwner?.id,
                  message: message
                }
              }}
              label={translations.sendMessageButtonLabel || directMessagingTranslations?.sendMessageButtonLabel || "Send"}
              onSuccess={(data) => {
                if (data.data.message && data.data.status == "NOK") {
                  dispatch(setDirectMessageError(data.data.message));
                } else {
                  setMessage("")
                }
                // if (data.data.status === "OK") {
                //   setCurrentMessage("")
                //   onSuccessfullySent ? onSuccessfullySent(data.data.support_chat_message) : null
                // } else {
                //   alert(data.data.message || "A error occurred sending the message.")
                // }
              }}
              onError={(error) => {
                console.log(error)
                dispatch(setDirectMessageError(translations.errorWhileSendingMessage || directMessagingTranslations?.errorWhileSendingMessage || "Error occurred while sending the chat message."))
                alert("Error sending chat message", error)
              }}
            />
          </div> : null}
        </div>
      </div>}
    </div>
  </>
}